<template>
    <div>
        <b-table-simple small bordered>
            <thead>
            <tr>
                <th>Fax Number</th>
                <th>Program Id</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="rule in routingRules" :key="rule.faxNumber">
                <td>
                    <b-input v-model="rule.faxNumber" />
                </td>
                <td>
                    <b-input type="number" v-model="rule.programId" />
                </td>
            </tr>
            </tbody>
            <tfoot>
            <b-button variant="success" size="sm" class="mx-2"
                @click="routingRules.push({ faxNumber: '', programId: 0 })">
                Add
            </b-button>
            </tfoot>
        </b-table-simple>
    </div>
</template>

<script lang="ts">
import { Component, VModel, Vue } from 'vue-property-decorator';
import { FaxRoutingRule } from "@/models/PriorAuthorization";

@Component({
    name: "FaxRoutingRuleField",
})
export default class FaxRoutingRuleField extends Vue {
    @VModel() routingRules!: FaxRoutingRule[];
}

</script>

<style scoped lang="scss">
::v-deep(thead th),
::v-deep(td) {
    padding: 1px 7px !important;
}

::v-deep(td) {
    height: 38px !important;
}

table ::v-deep(.actions) {
    width: 50px;
}

table ::v-deep(.active) {
    width: 40px;
}
</style>
